import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions/index";
import sampleCombine from 'xstream/extra/sampleCombine';
import { push } from 'react-router-redux'
import {reset} from "redux-form/immutable";

export function resetDepartmentFormAfterCreate(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_DEPARTMENT_SUCCESS)
    .map(action => reset('department'));

  return {
    ACTION: action$,
  }
}

export function redirectAfterDepartmentDelete(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_DEPARTMENT_SUCCESS)
    .map(action => (push('/departments')));

  return {
    ACTION: action$
  }
}

export function requestDeleteDepartment(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_DEPARTMENT)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/departments/' + action.payload.id,
      category: 'requestDeleteDepartment',
      method: 'DELETE',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestDeleteDepartment')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => actions.deleteDepartmentSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestDeleteDepartmentFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestDeleteDepartment')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 204)
    .map(response => actions.deleteDepartmentFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function redirectAfterUpdateDepartmentSuccess(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_DEPARTMENT_SUCCESS)
    .map(action => push('/departments'));

  return {
    ACTION: action$,
  }
}

export function requestUpdateDepartment(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_DEPARTMENT)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/departments/' + action.payload.id,
      category: 'requestUpdateDepartment',
      method: 'PATCH',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestUpdateDepartment')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.updateDepartmentSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestUpdateDepartmentFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestUpdateDepartment')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.updateDepartmentFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestDepartmentById(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_DEPARTMENT_BY_ID)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/departments/' + action.payload.id,
      category: 'requestDepartmentById',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestDepartmentById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getDepartmentByIdSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestDepartmentByIdFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestDepartmentById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getDepartmentByIdFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCreateDepartment(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_DEPARTMENT)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/departments',
      category: 'requestCreateDepartment',
      method: 'POST',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCreateDepartment')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.createDepartmentSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCreateDepartmentFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCreateDepartment')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.createDepartmentFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/department.js